import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Paper, Drawer, Button, Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
// import { logout } from '../../../store/userSlice'
import { changeBurgerExpanded } from '../../../store/layoutSlice'
import { Fab } from '@mui/material'
import { Clear } from '@mui/icons-material'
import Navigation from '../Navigation'
import logoRTG from '../../../images/logo_rtg_white.svg'
import atComputers from '../../../images/PoweredByATWhite.svg'

import { openPopup } from '../../../store/popupsSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsersMedical } from '@fortawesome/pro-solid-svg-icons'
import AddIcon from '@mui/icons-material/Add'

const styles = makeStyles((theme) => ({
  SideMenu: {
    display: 'none',
    flexDirection: 'column',
    height: '100%',
    width: '200px',
    zIndex: 1101,
    backgroundColor: theme.palette.primary.main,
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      minWidth: '320px',
      display: 'flex',
    },
  },
  popUpHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  drawerPaper: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.white.main,
    maxWidth: '70%',
    width: '100%',
    ['@media (min-width:450px)']: {
      maxWidth: '320px',
    },
  },
  redIcon: {
    color: theme.palette.white.light,
  },
}))

const SideMenu = () => {
  const dispatch = useDispatch()
  const classes = styles()
  const mobileOpen = useSelector((state) => state.layout.burgerExpanded)
  const user = useSelector((state) => state.user.user)

  const container = document.querySelector('body')

  return (
    <>
      <Paper square elevation={4} className={classes.SideMenu}>
        <Link to="/patients" className="hover:opacity-50 transition-all">
          <img src={logoRTG} alt="logo" />
        </Link>
        <Navigation />
        <Grid container item className="absolute bottom-0">
          <a
            href="https://atcomp.pl/"
            target="_blank"
            className="hover:opacity-50 transition-all p-9 pb-1 flex justify-center w-full"
            rel="noreferrer"
          >
            <img src={atComputers} alt="logo" />
          </a>
        </Grid>
      </Paper>
      <Drawer
        container={container}
        variant="temporary"
        anchor="left"
        open={mobileOpen}
        onClose={() => dispatch(changeBurgerExpanded({ value: false }))}
        classes={{
          paper: classes.drawerPaper,
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <div className={classes.popUpHeader}>
          <div className="flex gap-3 items-center">
            <Fab
              size="small"
              color="secondary"
              onClick={() => dispatch(changeBurgerExpanded({ value: false }))}
            >
              <Clear />
            </Fab>
            Menu
          </div>
          {user.role_id == 1 && (
            <div className="side_menu_w:hidden lg:hidden side_menu_nd_w:hidden flex items-center gap-1 justify-end header-btn">
              <Button
                startIcon={<FontAwesomeIcon icon={faUsersMedical} />}
                variant="contained"
                color="blue"
                onClick={() =>
                  dispatch(
                    openPopup({
                      component: 'PatientFactory',
                      title: 'Dodaj pacjenta',
                      level: 1,
                      key: 'patient-factory-popup',
                      maxWidth: 'sm',
                    })
                  )
                }
              >
                <p className="header_custom_w:hidden">Dodaj pacjenta</p>
              </Button>
              <Button
                startIcon={<AddIcon />}
                variant="contained"
                color="blue"
                onClick={() =>
                  dispatch(
                    openPopup({
                      component: 'ContractFactory',
                      title: 'Dodaj zlecenie',
                      level: 1,
                      maxWidth: 'xl',
                      key: 'contract-factory-popup',
                    })
                  )
                }
              >
                <p className="header_custom_w:hidden">Dodaj zlecenie</p>
              </Button>
            </div>
          )}
        </div>
        <Navigation />
        <Grid container item className="p-2 absolute bottom-0">
          <a
            href="https://atcomp.pl/"
            target="_blank"
            className="hover:opacity-50 transition-all p-9 pb-1 flex justify-center w-full"
            rel="noreferrer"
          >
            <img src={atComputers} alt="logo" />
          </a>
        </Grid>
        {user.role_id == 1 && (
          <div className="side_menu_th_w:hidden ml-3 mt-3 flex items-center gap-3 justify-start w-full header-btn">
            <Button
              startIcon={<FontAwesomeIcon icon={faUsersMedical} />}
              variant="contained"
              color="blue"
              onClick={() =>
                dispatch(
                  openPopup({
                    component: 'PatientFactory',
                    title: 'Dodaj pacjenta',
                    level: 1,
                    key: 'patient-factory-popup',
                    maxWidth: 'sm',
                  })
                )
              }
            >
              <p className="header_custom_w:hidden">Dodaj pacjenta</p>
            </Button>
            <Button
              startIcon={<AddIcon />}
              variant="contained"
              color="blue"
              onClick={() =>
                dispatch(
                  openPopup({
                    component: 'ContractFactory',
                    title: 'Dodaj zlecenie',
                    level: 1,
                    maxWidth: 'xl',
                    key: 'contract-factory-popup',
                  })
                )
              }
            >
              <p className="header_custom_w:hidden">Dodaj zlecenie</p>
            </Button>
          </div>
        )}
      </Drawer>
    </>
  )
}

export default SideMenu
